class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.exactSearchToggle = this.querySelector('[data-search-exact-toggle]');
    this.exactSearchControl = this.exactSearchToggle?.closest('.search-exact-toggle');
    this.searchField = this.input?.closest('.field');

    if (this.searchField && this.exactSearchControl) {
      this.updateSearchControlWidths = this.updateSearchControlWidths.bind(this);
      if (typeof ResizeObserver !== 'undefined') {
        this.searchControlResizeObserver = new ResizeObserver(this.updateSearchControlWidths);
        this.searchControlResizeObserver.observe(this.exactSearchControl);
        if (this.resetButton) this.searchControlResizeObserver.observe(this.resetButton);
      }
      this.updateSearchControlWidths();
    }

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onSearchFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.exactSearchToggle) {
      this.exactSearchToggle.addEventListener('change', this.onExactSearchChange.bind(this));
    }
  }

  getExactSearchValue(value, enabled) {
    const normalizedValue = value.trim().replace(/^"+/, '').replace(/"+$/, '');
    if (!enabled || normalizedValue.length === 0) return normalizedValue;

    return `"${normalizedValue}"`;
  }

  updateSearchControlWidths() {
    if (!this.searchField || !this.exactSearchControl) return;

    const exactToggleWidth = Math.ceil(this.exactSearchControl.getBoundingClientRect().width);
    const resetButtonWidth = this.resetButton && !this.resetButton.classList.contains('hidden')
      ? Math.ceil(this.resetButton.getBoundingClientRect().width)
      : 0;

    this.searchField.style.setProperty('--search-exact-toggle-width', `${exactToggleWidth}px`);
    this.searchField.style.setProperty('--search-reset-button-width', `${resetButtonWidth}px`);
  }

  applyExactSearchState() {
    if (!this.input || !this.exactSearchToggle) return;

    this.input.value = this.getExactSearchValue(this.input.value, this.exactSearchToggle.checked);
    this.toggleResetButton();
  }

  onSearchFormSubmit() {
    this.applyExactSearchState();
  }

  onExactSearchChange() {
    this.applyExactSearchState();
    if (this.input.value.trim().length === 0) {
      this.input.focus();
      return;
    }

    if (this.closest('search-drawer')) return;

    if (typeof this.input.form.requestSubmit === 'function') {
      this.input.form.requestSubmit();
    } else {
      this.input.form.submit();
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }

    this.updateSearchControlWidths?.();
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
